import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { PhoneNumberDetailSaveModel } from '../../phone-number-details/models/phone-number-detail-save.model';

export const addPhoneNumber = createAction('[Add PhoneNumber] Add PhoneNumber');

export const createPhoneNumber = createAction(
   '[Create PhoneNumber] Create PhoneNumber',
   props<{ phoneNumber: PhoneNumberDetailSaveModel }>()
);

export const createPhoneNumberAndAddAnother = createAction(
   '[Create PhoneNumber] Create PhoneNumber and Add Another',
   props<{ phoneNumber: PhoneNumberDetailSaveModel; accountName: string }>()
);

export const createPhoneNumberSuccess = createAction(
   '[API] Create PhoneNumber Success',
   props<{ phoneNumberId: number; _phoneNumber: string }>()
);

export const createPhoneNumberAndAddAnotherSuccess = createAction(
   '[API] Create PhoneNumber and Add Another Success',
   props<{ phoneNumberId: number; _phoneNumber: string; accountId: number; accountName: string }>()
);

export const createPhoneNumberFailure = createAction('[API] Create PhoneNumber Failure', props<SingleGraphError>());

export const createPhoneNumberAndAddAnotherFailure = createAction(
   '[API] Create PhoneNumber and Add Another Failure',
   props<SingleGraphError>()
);
